module.exports = __webpack_public_path__ + "static/media/grow_icon.44714122.png";